import { render } from "./DeactivatePropertyModal.vue?vue&type=template&id=29e16924"
import script from "./DeactivatePropertyModal.vue?vue&type=script&lang=js"
export * from "./DeactivatePropertyModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__